import { rate, rating } from "openskill";
import { gameTeams } from "@/utils/race-utils";

export function recalcScorecardsForRace(race) {
  const memberRatings = {};
  for (const snapshot of race.memberSnapshots) {
    memberRatings[snapshot.memberId] = {
      mu: snapshot.startOfRaceMu,
      sigma: snapshot.startOfRaceSigma
    };
  }

  const games = [...race.games].filter(game => !game.active).sort((a, b) => a.createdAt.toMillis() - b.createdAt.toMillis());

  for (let gi = 0; gi < games.length; gi++) {
    const game = games[gi];
    const gameNumber = gi + 1;

    const ratingsBySquad = race.actualSquadIds.map((squadId, si) =>
      gameTeams(race, game, gameNumber)[si].map(member =>
        member.id ? rating(memberRatings[member.id]) : rating({ mu: 25, sigma: 25 / 3 })
      )
    );

    const scores = game.scores || {};
    const squadScores = race.actualSquadIds.map(id => scores[id] || 0);
    const maxScore = Math.max(...squadScores);
    const ranks = squadScores.map(s => (s === maxScore ? 1 : 2));

    const newRatings = rate(ratingsBySquad, { rank: ranks });

    race.actualSquadIds.forEach((squadId, si) => {
      gameTeams(race, game, gameNumber)[si].forEach((member, pi) => {
        if (member.id) {
          memberRatings[member.id].mu = newRatings[si][pi].mu;
          memberRatings[member.id].sigma = newRatings[si][pi].sigma;
        }
      });
    });
  }

  return memberRatings;
}